'use client';

import HomeHero from "@/app/features/sites/home/ui/editable/HomeHero.editable";
import HomeIntro from "@/app/features/sites/home/ui/editable/HomeIntro.editable";
import HomeTiles from "@/app/features/sites/home/ui/editable/HomeTiles.editable";


export default function HomeViewEditable() {
    return (
        <>
            <HomeHero />
            <HomeIntro />
            <HomeTiles />
        </>
    )
}
